import React from "react";
// import chartImg from "../../assets/img/images/chart.png";
import Chart from "./Chart";
import { Link } from "react-router-dom";

const Sales = () => {
  const chart_info_list = [
    "Contingency: 70%",
    "Business Development: 10%",
    "Investor: 30%",
    "Poland",
    "Legal & Regulation:10%",
    "Czech Republic",
  ];

  return (
    <section id="sales" className="chart-area chart-bg pb-0">
      <div className="container">
        <div className="chart-inner">
          <div className="section-title">
            <h2 className="title mb-4">Token Distribution</h2>
          </div>
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-8 col-md-10 order-0">
              <div
                className="chart-wrap wow fadeInRight pt-lg-4"
                data-wow-delay=".2s"
              >
                <Chart />
                {/* <ul>
                  {chart_info_list.map((x, index) => (
                    <li key={index}>{x}</li>
                  ))}
                </ul> */}
              </div>
            </div>

            <div className="col-lg-4 col-md-10 px-lg-5">
              <div
                className="chart-content wow fadeInLeft"
                data-wow-delay=".2s"
              >
                <div className="text-start px-lg-5 pb-lg-4">
                  <h5 className="fs-6">Tokenomics</h5>
                  <p className="mb-0 font-14">Name : DIAG Token</p>
                  <p className="mb-0 font-14 py-2">
                    Total Supply : 50 Billion DIAG
                  </p>
                  <p className="font-14">Token Price : $0.01</p>
                  <div className="my-4 pt-lg-4 mb-0">
                    <Link className="btn border" to="/presale">
                      BUY NOW
                    </Link>
                  </div>
                </div>

                {/* <div className="d-lg-flex gap-lg-4 merriweather-sans pt-4">
                  <div>
                    <ul className="pl-2">
                      <li
                        style={{ listStyleType: "disc" }}
                        className="item1 mb-3"
                      >
                        Staking Rewards – 10%
                      </li>

                      <li
                        style={{ listStyleType: "disc" }}
                        className="item2 mb-3"
                      >
                        Rewards from Diagnostica App – 14%
                      </li>
                      <li
                        style={{ listStyleType: "disc" }}
                        className="item3 mb-3"
                      >
                        Reserve Pool – 14%
                      </li>
                      <li
                        style={{ listStyleType: "disc" }}
                        className="item4 mb-3"
                      >
                        Pre-Sale Investors – 12%
                      </li>
                      <li
                        style={{ listStyleType: "disc" }}
                        className="item5 mb-3"
                      >
                        Management – 10%
                      </li>
                    </ul>
                  </div>
                  <div>
                    <ul className="pl-2">
                      <li
                        style={{ listStyleType: "disc" }}
                        className="item6 mb-3"
                      >
                        Marketing – 8%
                      </li>
                      <li
                        style={{ listStyleType: "disc" }}
                        className="item6 mb-3"
                      >
                        Community Development – 10%
                      </li>

                      <li
                        style={{ listStyleType: "disc" }}
                        className="item7 mb-3"
                      >
                        Airdrops and Bounty Programs – 6%
                      </li>
                      <li
                        style={{ listStyleType: "disc" }}
                        className="item8 mb-3"
                      >
                        Advisors – 8%
                      </li>

                      <li style={{ listStyleType: "disc" }} className="item9">
                        Partners (Integrations) – 8%
                      </li>
                    </ul>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sales;
